export enum StepEnum {
  USER = 1,
  CONTACT = 2,
  CONFIRM_RESET = 3,
  CONFIRM_RESET_WITH_CODE = 4,
}

export enum MethodEnum {
  SMS = 1,
  EMAIL = 2,
}
